export const EventButtons = ({
  isFormValid,
  loading,
  isEditing,
  handleDelete,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-3 border-t border-slate-200 pt-6">
      <button
        type="submit"
        className="min-w-[140px] rounded-xl bg-red-500 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-red-600 disabled:cursor-not-allowed disabled:opacity-50"
        disabled={!isFormValid || loading}
      >
        {loading
          ? isEditing
            ? "UPDATING..."
            : "ADDING..."
          : isEditing
            ? "UPDATE"
            : "ADD"}
      </button>
      {isEditing && (
        <button
          type="button"
          className="min-w-[140px] rounded-xl bg-slate-700 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
          onClick={handleDelete}
          disabled={loading}
        >
          {loading ? "DELETING..." : "DELETE"}
        </button>
      )}
    </div>
  );
};
